var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconWallet = function SvgIconWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    fillRule: "evenodd",
    d: "M8.25 3.75a6 6 0 0 0-6 6v4.5a6 6 0 0 0 6 6h7.5a6 6 0 0 0 6-6v-4.5a6 6 0 0 0-6-6zM15 9a3 3 0 1 0 0 6h2a2.5 2.5 0 0 0 2.5-2.5v-1A2.5 2.5 0 0 0 17 9z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    d: "M16.5 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  })));
};
export default SvgIconWallet;